/* tslint:disable */
/* eslint-disable */
/**
 * Solid Slate
 * Booking, made easy
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Stage } from './Stage';
import {
    StageFromJSON,
    StageFromJSONTyped,
    StageToJSON,
    StageToJSONTyped,
} from './Stage';
import type { VenueTypeEnum } from './VenueTypeEnum';
import {
    VenueTypeEnumFromJSON,
    VenueTypeEnumFromJSONTyped,
    VenueTypeEnumToJSON,
    VenueTypeEnumToJSONTyped,
} from './VenueTypeEnum';

/**
 * Serializer for Venue model with comprehensive validation.
 * @export
 * @interface PatchedVenue
 */
export interface PatchedVenue {
    /**
     * 
     * @type {string}
     * @memberof PatchedVenue
     */
    readonly id?: string;
    /**
     * 
     * @type {number}
     * @memberof PatchedVenue
     */
    team?: number;
    /**
     * 
     * @type {string}
     * @memberof PatchedVenue
     */
    readonly teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedVenue
     */
    name?: string;
    /**
     * 
     * @type {VenueTypeEnum}
     * @memberof PatchedVenue
     */
    venueType?: VenueTypeEnum;
    /**
     * Address details: street, city, state, postal_code, country
     * @type {any}
     * @memberof PatchedVenue
     */
    address?: any | null;
    /**
     * Contact details: phone, email, website, social_media
     * @type {any}
     * @memberof PatchedVenue
     */
    contactInfo?: any | null;
    /**
     * Technical specifications: power, rigging, load_in, parking, etc.
     * @type {any}
     * @memberof PatchedVenue
     */
    technicalSpecs?: any | null;
    /**
     * 
     * @type {string}
     * @memberof PatchedVenue
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PatchedVenue
     */
    isActive?: boolean;
    /**
     * 
     * @type {Array<Stage>}
     * @memberof PatchedVenue
     */
    readonly stages?: Array<Stage>;
    /**
     * 
     * @type {string}
     * @memberof PatchedVenue
     */
    readonly stagesCount?: string;
    /**
     * 
     * @type {string}
     * @memberof PatchedVenue
     */
    readonly totalCapacity?: string;
    /**
     * 
     * @type {Date}
     * @memberof PatchedVenue
     */
    readonly createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof PatchedVenue
     */
    readonly updatedAt?: Date;
}



/**
 * Check if a given object implements the PatchedVenue interface.
 */
export function instanceOfPatchedVenue(value: object): value is PatchedVenue {
    return true;
}

export function PatchedVenueFromJSON(json: any): PatchedVenue {
    return PatchedVenueFromJSONTyped(json, false);
}

export function PatchedVenueFromJSONTyped(json: any, ignoreDiscriminator: boolean): PatchedVenue {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'team': json['team'] == null ? undefined : json['team'],
        'teamName': json['team_name'] == null ? undefined : json['team_name'],
        'name': json['name'] == null ? undefined : json['name'],
        'venueType': json['venue_type'] == null ? undefined : VenueTypeEnumFromJSON(json['venue_type']),
        'address': json['address'] == null ? undefined : json['address'],
        'contactInfo': json['contact_info'] == null ? undefined : json['contact_info'],
        'technicalSpecs': json['technical_specs'] == null ? undefined : json['technical_specs'],
        'description': json['description'] == null ? undefined : json['description'],
        'isActive': json['is_active'] == null ? undefined : json['is_active'],
        'stages': json['stages'] == null ? undefined : ((json['stages'] as Array<any>).map(StageFromJSON)),
        'stagesCount': json['stages_count'] == null ? undefined : json['stages_count'],
        'totalCapacity': json['total_capacity'] == null ? undefined : json['total_capacity'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'updatedAt': json['updated_at'] == null ? undefined : (new Date(json['updated_at'])),
    };
}

  export function PatchedVenueToJSON(json: any): PatchedVenue {
      return PatchedVenueToJSONTyped(json, false);
  }

  export function PatchedVenueToJSONTyped(value?: Omit<PatchedVenue, 'id'|'team_name'|'stages'|'stages_count'|'total_capacity'|'created_at'|'updated_at'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'team': value['team'],
        'name': value['name'],
        'venue_type': VenueTypeEnumToJSON(value['venueType']),
        'address': value['address'],
        'contact_info': value['contactInfo'],
        'technical_specs': value['technicalSpecs'],
        'description': value['description'],
        'is_active': value['isActive'],
    };
}

